// Wait until the entire HTML document is loaded and parsed.
document.addEventListener('DOMContentLoaded', () => {
	// --- Artifacts Grid Swiper Initialization ---
	const artifactGridSections = document.querySelectorAll(
		'.artifacts-grid-section'
	)

artifactGridSections.forEach((section) => {
  const swiperEl = section.querySelector('.artifacts-grid-swiper')
  const nextBtn = section.querySelector('.artifacts-grid-next')
  const prevBtn = section.querySelector('.artifacts-grid-prev')

  if (swiperEl && nextBtn && prevBtn) {
    const slides = swiperEl.querySelectorAll('.swiper-slide')

    if (slides.length === 0) {
      console.log('swiperEl',swiperEl);

       swiperEl.classList.add('single-slide')
      // Nếu chỉ có 1 item
      new Swiper(swiperEl, {
        slidesPerView: 1,
        centeredSlides: true,
        loop: false,
      })

      // Ẩn navigation vì không cần thiết
      nextBtn.style.display = 'none'
      prevBtn.style.display = 'none'
    } else {
      // Nếu có nhiều item thì giữ nguyên config cũ
      new Swiper(swiperEl, {
        loop: false,

        // Default settings (for mobile)
        slidesPerView: 1.5,
        spaceBetween: 16, // 1rem gap
        slidesOffsetAfter: 12,
        slidesOffsetBefore: 12,

        // Responsive breakpoints
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 16,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 16,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 16,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        },

        // Connect the navigation buttons
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      })
    }
  }
})

})
